import { atom } from "jotai";

export const previewNodeIdAtom = atom<string | null>(null);
previewNodeIdAtom.debugLabel = "previewNodeIdAtom";
